import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.24 2H18C18.5304 2 19.0391 2.21071 19.4142 2.58579C19.7893 2.96086 20 3.46957 20 4V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V9.24C4.0007 8.44462 4.31723 7.68207 4.88 7.12L9.12 2.88C9.68207 2.31723 10.4446 2.0007 11.24 2ZM6 10V20H18V4H12V9C12 9.26522 11.8946 9.51957 11.7071 9.70711C11.5196 9.89464 11.2652 10 11 10H6ZM8 13.5V12.5C8 12.3674 8.05268 12.2402 8.14645 12.1464C8.24021 12.0527 8.36739 12 8.5 12H15.5C15.6326 12 15.7598 12.0527 15.8536 12.1464C15.9473 12.2402 16 12.3674 16 12.5V13.5C16 13.6326 15.9473 13.7598 15.8536 13.8536C15.7598 13.9473 15.6326 14 15.5 14H8.5C8.36739 14 8.24021 13.9473 8.14645 13.8536C8.05268 13.7598 8 13.6326 8 13.5ZM8.5 16H12.5C12.6326 16 12.7598 16.0527 12.8536 16.1464C12.9473 16.2402 13 16.3674 13 16.5V17.5C13 17.6326 12.9473 17.7598 12.8536 17.8536C12.7598 17.9473 12.6326 18 12.5 18H8.5C8.36739 18 8.24021 17.9473 8.14645 17.8536C8.05268 17.7598 8 17.6326 8 17.5V16.5C8 16.3674 8.05268 16.2402 8.14645 16.1464C8.24021 16.0527 8.36739 16 8.5 16Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgFileTextOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgFileTextOutline;
